import { theme } from 'shared/styling';
import { capitalize } from 'utilities';

export const PUZZLE_TYPES = {
  static: 'static',
  video: 'video',
} as const;

export const PUZZLE_STATUSES = {
  new: 'new',
  pending: 'pending',
  edited: 'edited',
  approved: 'approved',
  rejected: 'rejected',
  disabled: 'disabled',
  deleted: 'deleted',
  processing: 'processing',
} as const;

export const PuzzleStatusConstants = {
  new: {
    color: theme.colors.info,
    label: 'New',
  },
  approved: {
    color: 'linear-gradient(180deg,#00c056 0%,#00bb54 13.02%,#009a45 100%)',
    label: 'Approved',
  },
  rejected: {
    color: 'red',
    label: 'Rejected',
  },
  deleted: {
    color: 'red',
    label: 'Deleted',
  },
  pending: {
    color: theme.colors.inProgress,
    label: 'Pending',
  },
  edited: {
    color: theme.colors.inProgress,
    label: 'Edited',
  },
  disabled: {
    color: 'gray',
    label: 'Disabled',
  },
} as const;

export const PUZZLE_DROPDOWN_OPTIONS = [
  { value: PUZZLE_STATUSES.new, label: capitalize(PUZZLE_STATUSES.new) },
  { value: PUZZLE_STATUSES.pending, label: capitalize(PUZZLE_STATUSES.pending) },
  { value: PUZZLE_STATUSES.edited, label: capitalize(PUZZLE_STATUSES.edited) },
  { value: PUZZLE_STATUSES.approved, label: capitalize(PUZZLE_STATUSES.approved) },
  { value: PUZZLE_STATUSES.rejected, label: capitalize(PUZZLE_STATUSES.rejected) },
  { value: PUZZLE_STATUSES.disabled, label: capitalize(PUZZLE_STATUSES.disabled) },
  { value: PUZZLE_STATUSES.deleted, label: capitalize(PUZZLE_STATUSES.deleted) },
  { value: PUZZLE_STATUSES.processing, label: capitalize(PUZZLE_STATUSES.processing) },
];

export const PUZZLE_TYPE_OPTIONS = [
  { value: PUZZLE_TYPES.static, label: capitalize(PUZZLE_TYPES.static) },
  { value: PUZZLE_TYPES.video, label: capitalize(PUZZLE_TYPES.video) },
];

const PUZZLE_IMAGE_PRINT_SHORT_EDGE = 2500;
const PUZZLE_IMAGE_PRINT_LONG_EDGE = 3333;

export const PUZZLE_IMAGE = {
  DIGITAL: {
    CROP_HQ: {
      WIDTH: 3072,
      HEIGHT: 3072,
      ASPECT_RATIO: 1,
    },
    CROP: {
      WIDTH: 2048,
      HEIGHT: 2048,
      ASPECT_RATIO: 1,
    },
    CROP_LQ: {
      WIDTH: 1024,
      HEIGHT: 1024,
      ASPECT_RATIO: 1,
    },
    CROP_ICON: {
      WIDTH: 256,
      HEIGHT: 256,
      ASPECT_RATIO: 1,
    },
  },
  PRINT: {
    LANDSCAPE: {
      MIN_WIDTH: PUZZLE_IMAGE_PRINT_LONG_EDGE,
      MIN_HEIGHT: PUZZLE_IMAGE_PRINT_SHORT_EDGE,
      ASPECT_RATIO: PUZZLE_IMAGE_PRINT_LONG_EDGE / PUZZLE_IMAGE_PRINT_SHORT_EDGE,
    },
    PORTRAIT: {
      MIN_WIDTH: PUZZLE_IMAGE_PRINT_SHORT_EDGE,
      MIN_HEIGHT: PUZZLE_IMAGE_PRINT_LONG_EDGE,
      ASPECT_RATIO: PUZZLE_IMAGE_PRINT_SHORT_EDGE / PUZZLE_IMAGE_PRINT_LONG_EDGE,
    },
  },
} as const;
